module.exports = __webpack_public_path__ + "img/k-yellow-woman-back.aabc2f86.jpg";